import React from 'react'
import styles from './Masthead.scss'
import appStyles from '../../App/appStyles.scss'
import { normalBlock } from '../../App/blockSizes.scss'
import cx from 'classnames'
import { Heart } from 'common/Heart'
import { SingleLineEditor } from 'common/SingleLineEditor'

export const Masthead = ({ title, subtitle, liked, likesCount, onHeartClick }) => (
  <div className={cx(styles.Masthead, normalBlock)}>
    <h1 className={appStyles.title}>{title}</h1>
    {subtitle && (
      <div className={appStyles.subtitle}>
        <SingleLineEditor
          defaultValue={subtitle}
          textAlignment='center'
          readOnly
          type='subtitle'
        />
      </div>
    )}
    <Heart liked={liked} count={likesCount} onClick={onHeartClick} />
  </div>
)
